export const CHRONICLE_CARD_WIDTH = 327
